
export default {
    path: 'oaManage',
    name: 'oaManage',
    component: () => import('@/pages/oa/indexList'),
    meta: { title: 'OA审批管理' },
    children: [
        // {
        //     path: ':id/table',
        //     name: 'oaTable',
        //     component: () => import('@/pages/oaManage/oaTable.vue'),
        //     meta: { title: '绩效目标一览' }
        // },
        {
            path: 'setting',
            name: 'oaSetting',
            component: () => import('@/pages/oa/workflow/SettingIndex.vue'),
            meta: { title: '审批流程设置' }
        },
        {
            path: 'old_setting',
            name: 'oldOASetting',
            component: () => import('@/pages/oaManage/Setting.vue'),
            meta: { title: '审批流程设置(旧版)' }
        },
        {
            path: ':workFlowDefId/workflow',
            name: 'workflow',
            component: () => import('@/pages/oa/workflow/FlowSetting.vue'),
            meta: { title: '流程设计' }
        },

    ]
}
